import { REPORTS_IDS } from '../constants/reportsRouteConfig'
import { getReportsRouteUrl } from './getReportsToRouteUrl'

export const isRouteValid = (route: string, organizationUrl: string | undefined): boolean => {
  if (!organizationUrl) {
    return false
  }

  return REPORTS_IDS.some((id) => getReportsRouteUrl(organizationUrl, id) === route)
}
